import { put, takeLatest, call } from "redux-saga/effects";
import {
	setListMerchant,
	setDetailMerchant,
	getListMerchantAsync,
	GetListMerchantAsyncPayload,
	getDetailMerchantAsync,
	GetDetailMerchantPayLoad,
	createMerchantAsync,
	CreateMerchantPayLoad,
	updateMerchantAsync,
	UpdateMerchantPayLoad,
	FilterListMerchantAsyncPayload,
	filterListMerchantAsync,
	getListCarPartAsync,
	GetListCarPartPayload,
	GetDetailCarPartPayload,
	getDetailCarPartAsync,
	UpdateStatusCarPartPayload,
	updateStatusCarPartAsync,
	setMerchantCarPartList,
	setMerchantCarPartDetail,
	changeStatusMerchantCarPart,
	getSubscriptionPakagesAsync,
	GetSubscriptionPakagesPayload,
	setSubscriptionPakages,
} from "./merchant.slice";
import { message } from "antd";
import { setLoadingPage } from "store/app/app.slice";
import api from "service/apiService";
import { t } from "@lingui/macro";
import { translate } from "utils";
import { PayloadAction } from "@reduxjs/toolkit";
import { Merchant, MerchantQueriesPayload } from "../types";
import { ApiResponse } from "types";
import ERROR_CODE from "constants/error-code";
import { getSubscriptionPakagesAPI } from "service/apis";

function* getListMerchantSaga(
	action: PayloadAction<GetListMerchantAsyncPayload>,
) {
	// yield put({ type: setLoadingPage.type, payload: true });
	const { query } = action.payload;
	if (typeof query.skip === "number" && typeof query.take === "number") {
		query.skip = query.skip * query.take;
	}

	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.get<ApiResponse<Merchant[]>>(
				"/dashboard/merchants",
				{
					...query,
					skip: query.skip,
				},
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		yield put({ type: setListMerchant.type, payload: response });
	} else {
		message.error(translate(error.message));
	}
	// yield put({ type: setLoadingPage.type, payload: false });
}

function* filterListMerchantSaga(
	action: PayloadAction<FilterListMerchantAsyncPayload>,
) {
	// yield put({ type: setLoadingPage.type, payload: true });
	const { query, callback } = action.payload;
	const queryClone: MerchantQueriesPayload = { ...query };
	if (typeof queryClone.saleStaff !== "number") {
		queryClone.saleStaffId = queryClone.saleStaff?.id;
	}

	if (
		typeof queryClone.skip === "number" &&
		typeof queryClone.take === "number"
	) {
		queryClone.skip = queryClone.skip * queryClone.take;
	}

	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.post<ApiResponse<Merchant[]>>(
				`/dashboard/merchants/filter?skip=${queryClone.skip}&take=${queryClone.take}`,
				queryClone,
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		yield put({ type: setListMerchant.type, payload: response });
	} else {
		message.error(translate(error.message));
	}

	callback && callback();
}

function* getDetailMerchantSaga(
	action: PayloadAction<GetDetailMerchantPayLoad>,
) {
	const { id } = action.payload;
	// yield put({ type: setLoadingPage.type, payload: true });
	const { response, error } = yield call(async () => {
		try {
			const response = await api.get(`/dashboard/merchants/${id}`);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		yield put({ type: setDetailMerchant.type, payload: response.data });
	} else {
		message.error(translate(error.message));
	}
	// yield put({ type: setLoadingPage.type, payload: false });
}

function* createMerchantSaga(action: PayloadAction<CreateMerchantPayLoad>) {
	const { data, returnStatus } = action.payload;
	yield put({ type: setLoadingPage.type, payload: true });
	const { response, error } = yield call(async () => {
		try {
			const response = await api.post("/dashboard/merchant", data);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		returnStatus(true);
	} else {
		message.error(translate(error.message));
		returnStatus(false);
	}
	yield put({ type: setLoadingPage.type, payload: false });
}

function* updateMerchantSaga(action: PayloadAction<UpdateMerchantPayLoad>) {
	const { id, callback, failtureCallback } = action.payload;
	const data = JSON.parse(JSON.stringify(action.payload.data));
	if (data.title?.trim() === "") data.title = null;
	if (data.contract === "") data.contract = null;
	if (data.email?.trim() === "") data.email = null;
	if (data.address?.trim() === "") data.address = null;
	if (typeof data.staff !== "number") data.staff = data.staff?.id;
	if (typeof data.saleStaff !== "number") data.saleStaffId = data.saleStaff?.id;
	if (data?.userAddress?.district?.id) {
		data.userAddress.district = data.userAddress.district.id;
	}
	if (data?.userAddress?.province?.id) {
		data.userAddress.province = data.userAddress.province.id;
	}
	if (data?.userAddress?.ward?.id) {
		data.userAddress.ward = data.userAddress.ward.id;
	}
	const { response, error } = yield call(async () => {
		try {
			const response = await api.put(`/dashboard/merchants/${id}`, data);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		yield put({ type: setDetailMerchant.type, payload: response.data });
		message.success(t`Update successful`);
	} else {
		failtureCallback && failtureCallback(error);
		if (error?.code !== ERROR_CODE.can_not_disable_merchant) {
			if (typeof error.message === "string") {
				message.error(translate(error.message));
			} else {
				message.error(translate(error.message.join(", ")));
			}
		}
	}
	callback && callback();
}

function* getListCarPartSaga(action: PayloadAction<GetListCarPartPayload>) {
	const { id, query, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const response = await api.get(
				id ? `/dashboard/merchants/${id}/car-parts` : `/dashboard/car-parts`,
				{ ...query },
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback?.();
		yield put({ type: setMerchantCarPartList.type, payload: response.data });
	} else {
		message.error(translate(error.message));
	}
}

function* watchGetListCarPart() {
	yield takeLatest(getListCarPartAsync, getListCarPartSaga);
}

function* getDetailCarPartSaga(action: PayloadAction<GetDetailCarPartPayload>) {
	const { carPartId, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const response = await api.get(`/dashboard/car-parts/${carPartId}`);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback();
		yield put({ type: setMerchantCarPartDetail.type, payload: response.data });
	} else {
		message.error(translate(error.message));
	}
}

function* watchGetDetailCarPart() {
	yield takeLatest(getDetailCarPartAsync, getDetailCarPartSaga);
}

function* getSubscriptionPakages(
	action: PayloadAction<GetSubscriptionPakagesPayload>,
) {
	const { callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const response = await getSubscriptionPakagesAPI();
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback && callback();
		yield put({ type: setSubscriptionPakages.type, payload: response.data });
	} else {
		message.error(translate(error.message));
	}
}

function* watchGetSubscriptionPakages() {
	yield takeLatest(getSubscriptionPakagesAsync, getSubscriptionPakages);
}

function* updateStatusCarPartSaga(
	action: PayloadAction<UpdateStatusCarPartPayload>,
) {
	const { merchantId, carPartId, data, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const response = await api.patch(
				`/dashboard/merchants/${merchantId}/car-parts/status/${carPartId}`,
				data,
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		yield put({ type: changeStatusMerchantCarPart.type, payload: data });
		message.success(t`Update successful`);
		callback?.();
	} else {
		message.error(translate(error.message));
	}
}

function* watchUpdateStatusCarPart() {
	yield takeLatest(updateStatusCarPartAsync, updateStatusCarPartSaga);
}

function* watchGetListMerchant() {
	yield takeLatest(getListMerchantAsync, getListMerchantSaga);
}

function* watchFilterListMerchant() {
	yield takeLatest(filterListMerchantAsync, filterListMerchantSaga);
}

function* watchGetDetailMerchant() {
	yield takeLatest(getDetailMerchantAsync, getDetailMerchantSaga);
}

function* watchCreateMerchant() {
	yield takeLatest(createMerchantAsync, createMerchantSaga);
}

function* watchUpdateMerchant() {
	yield takeLatest(updateMerchantAsync, updateMerchantSaga);
}

const merchantSaga = [
	watchGetListMerchant(),
	watchGetDetailMerchant(),
	watchCreateMerchant(),
	watchUpdateMerchant(),
	watchFilterListMerchant(),
	watchGetListCarPart(),
	watchGetDetailCarPart(),
	watchUpdateStatusCarPart(),
	watchGetSubscriptionPakages(),
];
export default merchantSaga;
